<template>
  <div>
    <header data-test="header">
      <div class="center_block">
        <v-row class="header-content" no-gutters>
          <v-col v-if="communityData.translation.featured_image" class="col-2">
            <div class="community-logo" :style="{'background-image': `url(${communityData.translation.featured_image})`}"></div>
          </v-col>
          <v-col :class="(communityData.translation.featured_image) ? 'col-7' : 'col-9'" class="community-title">
            <h1>{{ communityData.translation.title }}</h1>
            <p>{{ communityData.translation.short_description }}</p>
          </v-col>
          <v-col class="col-3">
            <button
              v-if="communityData.metadata.publisher"
              class="button community-search"
              data-test="community_search_link"
              @click="onCommunitySearch"
            >
              {{ $t("Show-all-materials", {count: communityData.metadata.materials_count}) }}
            </button>
          </v-col>
        </v-row>
        <v-row class="header-tabs">
          <v-tabs v-model="tabIndex" :color="$vuetify.theme.defaults.light.accent">
            <v-tab v-if="(communityData.collections && communityData.collections.length) || (communityData.dynamic_collections && communityData.dynamic_collections.length)">
              <span v-if="communityData.collections && communityData.dynamic_collections">
                {{ $t("collections") }} ({{ communityData.collections.length + communityData.dynamic_collections.length }})
              </span>
              <span v-else-if="communityData.collections">
                {{ $t("collections") }} ({{ communityData.collections.length }})
              </span>
              <span v-else-if="communityData.dynamic_collections">
                {{ $t("collections") }} ({{ communityData.dynamic_collections.length }})
              </span>
            </v-tab>
            <v-tab>{{ $t("About-this-community") }}</v-tab>
          </v-tabs>
        </v-row>
      </div>
    </header>

    <div class="center_block" data-test="content">
      <v-row no-gutters>
        <v-col class="col-10">
          <v-tabs-items v-model="tabIndex">
            <v-tab-item v-if="(communityData.collections && communityData.collections.length) || (communityData.dynamic_collections && communityData.dynamic_collections.length)">
              <Collections
                :collections="communityData.collections"
                class="community__collections"
              >
              </Collections>
              <section v-for="dynamicCollectionGroup in communityData.dynamic_collections" :key="dynamicCollectionGroup.id">
                <h2>{{ $i18n.locale === "nl" ? dynamicCollectionGroup.title_dutch : dynamicCollectionGroup.title_english }}</h2>
                <div>{{ $i18n.locale === "nl" ? dynamicCollectionGroup.description_dutch : dynamicCollectionGroup.description_english }}</div>
                <DynamicCollectionCards
                  :collections="dynamicCollectionGroup.bundles"
                  class="collections"
                >
                </DynamicCollectionCards>
              </section>
            </v-tab-item>
            <v-tab-item>
              <div class="community-description" v-html="sanitizedDescription"></div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col class="col-2">
          <div class="community-info">
            <a v-if="communityData.translation.website_url" :href="communityData.translation.website_url" target="_blank">
              {{ $t("Visit-website") }}&nbsp;<v-icon x-small :color="$vuetify.theme.defaults.light.anchor">fa-arrow-up-right-from-square</v-icon>
            </a>
          </div>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import Collections from "~/components/Collections";
import DynamicCollectionCards from "~/components/Collections/DynamicCollectionCards.vue";
import DOMPurify from "dompurify";

export default {
  name: "CommunityDesktop",
  components: {
    Collections,
    DynamicCollectionCards,
  },
  props: {
    communityData: {
      type: Object,
      default: () => ({}),
    },
    onCommunitySearch: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    goToDynamicCollection(url) {
      let domain = location.origin.replace("search.", "");
      location.href = `${domain}${url}`;
    },
  },
  watch: {
    communityData: function(data) {
      this.tabIndex =  (!!data.collections && !!data.collections.length) || (!!data.dynamic_collections && !!data.dynamic_collections.length) ? 1 : 0;
    }
  },
  data() {
    return {
      tabIndex: (!!this.communityData.collections && !!this.communityData.collections.length) || (!!this.communityData.dynamic_collections && !!this.communityData.dynamic_collections.length) ? 1 : 0,
      sanitizedDescription: DOMPurify.sanitize(this.communityData.translation.description),
  }
    ;
  },
};

</script>

<style lang="less" scoped>
@import url("../../variables");

@header-height: 140px;

header {
  height: 250px;
  background-color: @lighter-grey;
  padding-top: 32px;

  .header-content {
    height: @header-height;
  }

  .community-logo {
    width: @header-height;
    height: @header-height;
    background-position: left center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: @white;
  }

  .community-title h1 {
    margin: 0;
  }

  .header-tabs {
    margin-top: 30px;
  }

  .community-search.button {
    float: right;
  }
}

.community-description {
  padding: 20px;
}

.community-info {
  padding: 20px;
}

.collections {
  width: 100%;
  &.community__collections h2 {
    margin-bottom: 10px;
  }
  h2 {
    margin-bottom: 81px;
  }
  &__items {
    margin-top: 20px;
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
    grid-gap: 1rem;
    cursor: pointer;

    .select-icon {
      background: @light-grey url('../../assets/images/close-grey.svg') 50% 50% no-repeat;
      background-size: 20px 20px;
      position: absolute;
      left: 50%;
      top: -20px;
      width: 40px;
      height: 40px;
      color: transparent;
      overflow: hidden;
      padding: 0;
      cursor: pointer;
      z-index: 1;
      border-radius: 50%;
      transform: translate(-50%, 0);
      border: 0;

      &:focus {
        outline: none;
      }
    }
  }
  &__description {
    font-size: 20px;
    line-height: 1.15;
    margin: 1px 0 76px;
  }

  &__item {
    list-style: none;
    background-color: #fff;
    position: relative;
    font-size: 16px;
    line-height: 1.44;

    &_wrapper {
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &_wrapper.selected {
      opacity: 0.5;
      pointer-events: none;
    }

    &_header {
      padding: 0 10px 0 31px;
      position: relative;
      margin: 0 0 20px;
      font-weight: bold;
      font-family: @second-font;
      &:before {
        content: '';
        background: url('../../assets/images/keurmerk.svg') no-repeat 0 0;
        height: 39px;
        width: 24px;
        position: absolute;
        top: -8px;
        left: 0;
      }
    }
    &_ttl {
      line-height: 1.2;
      margin-bottom: 20px;
      flex: 1;

      &_link {
        text-decoration: none;
        color: transparent;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.tile {
  position: relative;
  word-break: break-word;
  margin-bottom: 23px;
  margin-top: 15px;

  &__wrapper {
    position: relative;
    overflow: hidden;
    height: 100%;
    border-radius: 10px;
    box-shadow: 5px 5px 10px 5px rgba(204, 204, 204, 0.4);

    &.stack {
      background: transparent url("../../assets/images/card-flip.svg") 100.2% -2px no-repeat;
    }
  }
}

.collection-card {
  height: 100%;
}
</style>
